<template>
  <div v-if="yearsToSelect" id="tax-summary">
    <TaxGuideAlert />

    <v-card class="px-5 py-2 mt-4 mb-0 elevation-0">
      <v-chip-group v-model="yearSelected" active-class="primary" mandatory show-arrows>
        <v-chip
          v-for="year in yearsToSelect"
          :key="year"
          filter
          outlined
          :value="year"
          @click="yearClicked(year)"
        >
          {{ $t('views.tax.taxSummary.taxYear') }} {{ year }}
        </v-chip>
      </v-chip-group>
    </v-card>

    <SomePositionIncomplete />

    <v-card v-if="somePendingRecreatePosition" class="pa-4 pt-7 mt-4 elevation-0">
      <TaxSomePositionRecreating />
    </v-card>
    <v-row v-else>
      <v-col cols="12" md="12" lg="6" class="py-0 mt-5">
        <TaxSummaryKeyPoints
          :yearSummary="yearSummary"
          :yearSelected="yearSelected"
          :startDate="startDate"
          :endDate="endDate"
          :loading="loading"
          :hideDataNoPlanUser="hideDataNoPlanUser"
        />
      </v-col>

      <v-col cols="12" md="12" lg="6" class="py-0 mt-5">
        <TaxSummaryDividendsKeyPoints
          :yearSummary="yearSummary"
          :yearSelected="yearSelected"
          :startDate="startDate"
          :endDate="endDate"
          :loading="loading"
          :hideDataNoPlanUser="hideDataNoPlanUser"
        />
      </v-col>

      <v-col col="12" md="12" lg="12" class="pb-0 mt-3">
        <OrdersProfitByPositionType
          ref="ordersProfitByPositionType"
          :showChart="false"
          alwaysShowCash
          :itemsPerPage="10"
          :hideDataNoPlanUser="hideDataNoPlanUser"
        />
      </v-col>

      <v-col cols="12" md="12" class="pb-0 mt-1">
        <TaxSummaryProfitByPosition
          :yearSummary="yearSummary"
          :yearSelected="yearSelected"
          :startDate="startDate"
          :endDate="endDate"
          :loading="loading"
          :hideDataNoPlanUser="hideDataNoPlanUser"
        />
      </v-col>

      <v-col cols="12" md="12" class="pb-0 mt-1">
        <PortfolioEndOfYear
          ref="portfolioEndOfYear"
          :year="yearSelected"
          :hideDataNoPlanUser="hideDataNoPlanUser"
        />
      </v-col>

      <v-col cols="12" md="12" class="pb-0 mt-3">
        <DividendsByPosition
          ref="dividendsByPosition"
          :showChart="false"
          :itemsPerPage="10"
          :hideDataNoPlanUser="hideDataNoPlanUser"
        />
      </v-col>

      <v-col cols="12" md="12" class="mt-6 py-4">
        <TaxDisclaimer />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { getTaxSummary, getSummary } from '@/lib/api.js'
import taxMixin from '@/views/components/tax/taxMixin'
import TaxGuideAlert from '@/views/components/tax/TaxGuideAlert'
import TaxDisclaimer from '@/views/components/tax/TaxDisclaimer'
import TaxSomePositionRecreating from '@/views/components/tax/TaxSomePositionRecreating'
import TaxSummaryKeyPoints from '@/views/components/tax/taxSummary/TaxSummaryKeyPoints'
import TaxSummaryDividendsKeyPoints from '@/views/components/tax/taxSummary/TaxSummaryDividendsKeyPoints'
import TaxSummaryProfitByPosition from '@/views/components/tax/taxSummary/TaxSummaryProfitByPosition'
import OrdersProfitByPositionType from '@/views/components/dashboardDetail/orders/OrdersProfitByPositionType'
import PortfolioEndOfYear from '@/views/components/tax/taxSummary/PortfolioEndOfYear'
import DividendsByPosition from '@/views/components/dashboardDetail/dividends/DividendsByPosition.vue'

export default {
  components: {
    TaxGuideAlert,
    TaxDisclaimer,
    TaxSomePositionRecreating,
    TaxSummaryKeyPoints,
    TaxSummaryDividendsKeyPoints,
    TaxSummaryProfitByPosition,
    OrdersProfitByPositionType,
    PortfolioEndOfYear,
    DividendsByPosition,
  },
  mixins: [taxMixin],
  data() {
    return {
      tab: 'taxSummary',
      yearSummary: {},
    }
  },
  async mounted() {
    const portfolioAge = await getSummary({
      type: 'portfolio-age',
    })
    this.yearsToSelect = portfolioAge.data.map((elem) => {
      return elem.toString()
    })
    this.yearSelected = this.yearsToSelect[this.yearsToSelect.length - 1]
  },
  methods: {
    async loadData(startDate, endDate) {
      const yearSummary = await getTaxSummary({ startDate, endDate })
      this.yearSummary = yearSummary.data

      if (this.$refs.dividendsByPosition)
        this.$refs.dividendsByPosition.loadSummary({
          type: 'stockDividend',
          date: { $gte: this.startDate, $lte: this.endDate },
        })
      if (this.$refs.ordersProfitByPositionType)
        this.$refs.ordersProfitByPositionType.loadSummary({
          date: { $gte: this.startDate, $lte: this.endDate },
        })
      if (this.$refs.portfolioEndOfYear) this.$refs.portfolioEndOfYear.init()
    },
  },
}
</script>
